<template>
  <section>
    <h1>Past Projects</h1>
    <p v-if="rfq && rfq.product_brand == 'Mitrex'">
      By Our Sister Company Cladify
    </p>
    <hr class="h1-underline"/>

    <div class="relative-container short mt-1">
      <div class="project project--right">
        <div class="project__text">
          <div class="title is-5">
            AQUABELLA
          </div>
          <div class="subtitle is-6">118 Merchants’ Wharf, Toronto, Ontario, Canada</div>
          <p class="is-size-7">
            Aquabella is the third phase of Tridel and Hines’
            condominium community at Bayside on the
            Toronto Waterfront. Designed by Danish
            architect 3XN, the building is 12 storeys tall and
            has 173 units. We cut overall installation time in
            half by proposing a pre-panelized system that
            simulates an intricate mosaic design. All corners
            and panel profiles were pre-fabricated and
            assembled in our Toronto-based factory.
          </p>
        </div>
        <div class="project__image">
          <img
            class="exception" 
            src="https://camas.app/resources/static/images/images/image__bdc059498835e830bd0f0b001511975f.png"/>
        </div>
        <div class="project__details">
          <div>
            <span>
              DEVELOPER:
            </span>
            <span class="has-text-weight-bold">
              Tridel, Hines
            </span>
          </div>
          <div>
            <span>
              ARCHITECT:
            </span>
            <span class="has-text-weight-bold">
              3XN, Kirkor Architects and Planners
            </span>
          </div>
          <div>
            <span>
              BUILDING TYPE:
            </span>
            <span class="has-text-weight-bold">
              Condo, Retail
            </span>
          </div>
        </div>
      </div>

      <div class="project project--left">
        <div class="project__image">
          <img
            class="exception" 
            src="https://camas.app/resources/static/images/images/image__d66b96e5687f7df2147a3f8cc6635c8c.png"/>
        </div>
        <div class="project__text">
          <div class="title is-5">
            357 KING WEST
          </div>
          <div class="subtitle is-6">
            357 King Street West, Toronto, Ontario, Canada
          </div>
          <p class="is-size-7">
            357 King West is a new 42-storey, 324-unit condo
            building on the edge of Toronto’s Entertainment
            District. Developed by Great Gulf, it features
            rooftop terraces and outdoor lounges. Our sleek,
            lightweight cladding system made installation
            easy. We significantly reduced installation time by
            pre-assembling all corners at our factory in
            Toronto. We also provided a rainscreen system
            with thermally broken cladding brackets to
            improve building insulation and waterproofing.
          </p>
        </div>
        <div class="project__details">
          <div>
            <span>
              DEVELOPER:
            </span>
            <span class="has-text-weight-bold">
              Great Gulf
            </span>
          </div>
          <div>
            <span>
              ARCHITECT:
            </span>
            <span class="has-text-weight-bold">
              Quadrangle
            </span>
          </div>
          <div>
            <span>
              BUILDING TYPE:
            </span>
            <span class="has-text-weight-bold">
              Condo, Rental, Retail
            </span>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  props: {
    rfq: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/past-projects.scss';
</style>
